module.exports = __webpack_public_path__ + "static/media/tzion.d2dfc1f5.png";